import { createSlice } from "@reduxjs/toolkit";
import ApiTrails from "../../api/trail";

export const AuditSubjectTrailsSlice = createSlice({
  name: "subjectTrails",
  initialState: {
    trails: null,
    hasMore: false,
    isLoading: false,
  },
  reducers: {
    setTrails: (state, action) => {
      const current = state.trails || [];
      const incoming = action.payload || [];

      const existingIds = new Set(current.map((item) => item.id));
      const newItems = incoming.filter((item) => !existingIds.has(item.id));

      return {
        ...state,
        trails: [...current, ...newItems],
        hasMore: incoming.length === 30,
        isLoading: false,
      };
    },
    resetTrails: (state) => ({
      ...state,
      trails: [],
      hasMore: false,
      isLoading: false,
    }),
    setLoading: (state) => ({ ...state, isLoading: true }),
  },
});

export const { setTrails, resetTrails, setLoading } =
  AuditSubjectTrailsSlice.actions;

export const fetchSubjectTrails = (query) => (dispatch) => {
  dispatch(setLoading());
  ApiTrails.getSubjectTrails(query).then((r) => {
    dispatch(setTrails(r.data.trails));
  });
};

export const clearSubjectTrails = () => (dispatch) => {
  dispatch(resetTrails());
};

export const selectSubjectTrails = (state) => state.subjectTrails.trails;
export const selecthasMoreSubjectTrails = (state) =>
  state.subjectTrails.hasMore;
export const selectSubjectTrailsLoading = (state) =>
  state.subjectTrails.isLoading;

export default AuditSubjectTrailsSlice.reducer;
